module.exports = __webpack_public_path__ + "r-v3/img/sticker_1.d7681a55.svg";